<template>
  <div class="tai-xiu-history-big-small">
    <Row type="flex">
      <Col id="tai-xiu-history-big" class="history-stat-bar">
        {{ $t("tai_xiu.o1") }}
        <span>{{ stat.stat_bs_b }}%</span>
      </Col>
      <Col id="tai-xiu-history-triple" class="history-stat-bar">
        {{ $t("tai_xiu.o3") }}
        <span>{{ stat.stat_bs_t }}%</span>
      </Col>
      <Col id="tai-xiu-history-small" class="history-stat-bar">
        {{ $t("tai_xiu.o2") }}
        <span>{{ stat.stat_bs_s }}%</span>
      </Col>
    </Row>

    <Row type="flex" justify="space-around">
      <Col
        class="tai-xiu-history-trend-lot-col"
        :class="{
          big: col[0].win === 'B',
          small: col[0].win === 'S',
          triple: col[0].win === 'T'
        }"
        v-for="(col, index) in trimHistoricalData"
        :key="index"
      >
        <div v-for="(cell, index) in col" :key="index" class="tai-xiu-history-trend-lot-cell">
          <bet-history-popper
            :game="game"
            :table-name="tableName"
            :cell-data="cell"
            :game-code="gameCode"
            :game-id="gameId"
          >{{ getChar(cell.win) }}</bet-history-popper>
        </div>
      </Col>
    </Row>
  </div>
</template>

<script>
import { Row, Col } from "iview";
import {
  size,
  reduce,
  pickBy,
  toArray,
  reverse,
  find,
  reduceRight
} from "lodash";
import BetHistoryPopper from "../widgets/BetHistoryPopper";
import { TimelineMax } from "gsap";

export default {
  props: ["stat", "historicalData", "game", "gameCode", "gameId", "tableName"],
  components: {
    Row,
    Col,
    BetHistoryPopper
  },
  data() {
    return {
      remappedhistoricalData: [],
      maxCellCol: 5,
      lastDrawID: "",
      previousBadgeCount: 0
    };
  },

  computed: {
    trimHistoricalData() {
      let last18Cols = pickBy(this.remappedhistoricalData, function(
        item,
        index
      ) {
        return true; //index < 18;
      });

      this.triggerBlinkingEffect();

      return toArray(last18Cols);
    }
  },
  watch: {
    remappedhistoricalData() {
      let tempArr = toArray(this.remappedhistoricalData);
      let arrLength = tempArr.length;
      let emitArr = ["b_s", "general.sum_bs_short"];
      let tempValue = 0;

      if (arrLength > 0) {
        if (
          tempArr[arrLength - 1][0]["bs"] == tempArr[arrLength - 2][0]["bs"]
        ) {
          tempValue =
            tempArr[arrLength - 1].length + tempArr[arrLength - 2].length;
        } else {
          tempValue = tempArr[arrLength - 1].length;
        }

        if (tempValue > 3) emitArr.push(tempValue);
        else {
          emitArr.push(0);
          tempValue = 0;
        }
        emitArr.push(tempArr[arrLength - 1][0]["bs"]);

        if (tempArr[arrLength - 1][0]["bs"] == 1) {
          emitArr.push("goodRoadIconRed");
        } else {
          emitArr.push("goodRoadIconDarkBlue");
        }

        if (this.previousBadgeCount != tempValue) {
          this.$emit("get-badge-count", emitArr);
        }

        this.previousBadgeCount = tempValue;
      }
    },
    historicalData() {
      let totalCol = 0;
      let totalItem = 0;
      let tempData = [...this.historicalData];
      reduce(
        tempData,
        (acc, cur) => {
          let curr = { ...cur };
          if (typeof curr === "undefined") return { ...acc };

          if (parseInt(curr.triple)) {
            curr.win = "T";
          } else if (parseInt(curr.bs) === 1) {
            curr.win = "B";
          } else {
            curr.win = "S";
          }

          if (!size(acc)) {
            return {
              ...acc,
              [size(acc)]: (acc[size(acc)] || []).concat(curr)
            };
          } else {
            let lastObjectArray = acc[size(acc) - 1] || [];
            let lastArrayItem = size(lastObjectArray)
              ? lastObjectArray[size(lastObjectArray) - 1]
              : {};
            let lastItemWin = lastArrayItem.win;

            if (
              lastItemWin === curr.win &&
              size(lastObjectArray) < this.maxCellCol
            ) {
              if (totalCol < 18) {
                totalItem++;
              }
              return {
                ...acc,
                [size(acc) - 1]: (acc[size(acc) - 1] || []).concat(curr)
              };
            } else {
              totalCol++;

              if (totalCol < 18) {
                totalItem++;
              } else {
                tempData.splice(totalItem);
                return { ...acc };
              }

              return {
                ...acc,
                [size(acc)]: (acc[size(acc)] || []).concat(curr)
              };
            }
          }
        },
        {}
      );

      reverse(tempData);

      this.remappedhistoricalData = reduce(
        tempData,
        (acc, cur) => {
          let curr = { ...cur };
          if (parseInt(curr.triple)) {
            curr.win = "T";
          } else if (parseInt(curr.bs) === 1) {
            curr.win = "B";
          } else {
            curr.win = "S";
          }

          if (!size(acc)) {
            return {
              ...acc,
              [size(acc)]: (acc[size(acc)] || []).concat(curr)
            };
          } else {
            let lastObjectArray = acc[size(acc) - 1] || [];
            let lastArrayItem = size(lastObjectArray)
              ? lastObjectArray[size(lastObjectArray) - 1]
              : {};
            let lastItemWin = lastArrayItem.win;

            if (
              lastItemWin === curr.win &&
              size(lastObjectArray) < this.maxCellCol
            ) {
              return {
                ...acc,
                [size(acc) - 1]: (acc[size(acc) - 1] || []).concat(curr)
              };
            } else {
              // reverse(lastObjectArray);
              return {
                ...acc,
                [size(acc)]: (acc[size(acc)] || []).concat(curr)
              };
            }
          }
        },
        {}
      );
    }
  },
  methods: {
    getChar: function getChar(value) {
      if (value == "B") {
        return this.$t("tai_xiu.o1_trend");
      } else if (value == "T") {
        return this.$t("tai_xiu.o3_trend");
      } else if (value == "S") {
        return this.$t("tai_xiu.o2_trend");
      }
    },

    triggerBlinkingEffect() {
      this.$nextTick(() => {
        let animationTl = new TimelineMax();

        animationTl
          .to(
            "#game-" +
              this.gameId +
              " .tai-xiu-history-big-small .tai-xiu-history-trend-lot-col:last-of-type .tai-xiu-history-trend-lot-cell:last-of-type",
            0.5,
            {
              opacity: 0
            }
          )
          .to(
            "#game-" +
              this.gameId +
              " .tai-xiu-history-big-small .tai-xiu-history-trend-lot-col:last-of-type .tai-xiu-history-trend-lot-cell:last-of-type",
            0.5,
            {
              opacity: 1
            }
          );

        animationTl.repeat(4);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.tai-xiu-history-trend-lot-col {
  flex: 1.333333333;
  height: 100%;
}
</style>

<style lang="scss">
.tai-xiu-history-trend-lot-cell {
  text-align: center;
  font-size: 10px;
  font-weight: bold;
  width: 16px;
  height: 16px;
  background-color: #ffffff;
  border-radius: 100px;
  margin-top: 6px;
  cursor: pointer;
  overflow: hidden;
}

#tai-xiu-history-triple {
  background-color: $tai-xiu-theme-color-12;
  color: $tai-xiu-theme-color-4;
}
#tai-xiu-history-small {
  background-color: $tai-xiu-theme-color-12;
  color: $tai-xiu-theme-color-4;
}
#tai-xiu-history-big {
  background-color: $tai-xiu-theme-color-12;
  color: $tai-xiu-theme-color-4;
}
.tai-xiu-history-trend-lot-col.small .tai-xiu-history-trend-lot-cell {
  background-color: $tai-xiu-theme-color-8;
  color: $tai-xiu-theme-color-5;
}
.tai-xiu-history-trend-lot-col.big .tai-xiu-history-trend-lot-cell {
  background-color: $tai-xiu-theme-color-9;
  color: $tai-xiu-theme-color-5;
}
.tai-xiu-history-trend-lot-col.even .tai-xiu-history-trend-lot-cell {
  background-color: $tai-xiu-theme-color-4;
  color: $tai-xiu-theme-color-5;
}

.tai-xiu-history-trend-lot-col.triple .tai-xiu-history-trend-lot-cell {
  background-color: $tai-xiu-theme-color-3;
  color: $tai-xiu-theme-color-5;
}
</style>
